
const StartComponent = () => {
    return (
        <>
            <h1>hey, im lyxt</h1>
            <p>i specialize in <i>backend web development</i> with a strong focus on clean and functional programming.
                i have a keen interest in <i>minimalist design</i>, <i>prioritizing simplicity</i> in user interfaces and <i>overall approach</i>.
                <i> consistency</i> is my mantra, as it streamlines processes and makes life easier.
            </p>
            <p>you can check out my socials here:</p>
            <ul>
                <li><a target={'_blank'} rel={'noreferrer'} href={'https://github.com/6lyxt'}>github</a></li>
                <li><a target={'_blank'} rel={'noreferrer'} href={'https://twitter.com/6lyxt'}>x</a></li>
                <li><a target={'_blank'} rel={'noreferrer'} href={'https://instagram.com/lyxt.png'}>instagram</a></li>
            </ul>
        </>
    );
}

export default StartComponent;
